module.exports = "/_next/static/images/Personalization-xs-4a642349017463267c5ac3c5c9be015f.png";